import React from 'react';
const CHECKOUT_URL = 'https://italia.edulabs.online/cart/43365259772022:1';
export function PricingSection() {
  const firePixel = () => {
    const w = window as any;
    if (w.fbq) {
      w.fbq('track', 'AddToCart', {
        content_name: 'Musica Pronta Bundle',
        content_type: 'product',
        value: 19,
        currency: 'EUR'
      });
    }
  };
  return <section className="w-full bg-bg-dark py-14 sm:py-28 px-4 sm:px-6 relative overflow-hidden pt-[40px] pb-[40px]" data-id="element-273">
      {/* Background Glows */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] rounded-full pointer-events-none" style={{
      background: 'radial-gradient(circle, rgba(234,88,12,0.08) 0%, transparent 70%)'
    }} data-id="element-274"></div>
      <div className="absolute bottom-0 right-0 w-[400px] h-[400px] rounded-full pointer-events-none" style={{
      background: 'radial-gradient(circle, rgba(16,185,129,0.08) 0%, transparent 70%)'
    }} data-id="element-275"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-276">
        <h2 className="sm:text-6xl font-black text-text-main text-center mb-6 sm:mb-16 tracking-tight text-[28px]" data-id="element-277">
          L'Offerta "Musica Pronta"
        </h2>

        {/* Featured Card */}
        <div className="bg-bg-alt rounded-xl sm:rounded-3xl border border-primary/50 shadow-[0_0_50px_rgba(59,130,246,0.15)] px-5 py-7 sm:p-14 flex flex-col relative w-full sm:w-[90%] mx-auto" data-id="element-278">
          {/* Glowing Border Effect */}
          <div className="absolute inset-0 rounded-xl sm:rounded-3xl border-2 border-transparent bg-gradient-to-b from-primary/50 to-transparent opacity-50 pointer-events-none" style={{
          maskImage: 'linear-gradient(to bottom, black, transparent)',
          WebkitMaskImage: 'linear-gradient(to bottom, black, transparent)'
        }} data-id="element-279"></div>

          <div className="absolute -top-3 sm:-top-5 left-1/2 -translate-x-1/2 bg-gradient-to-r from-secondary to-yellow-400 text-bg-dark font-black text-[10px] sm:text-base px-4 sm:px-8 py-1 sm:py-2.5 rounded-full whitespace-nowrap shadow-[0_0_20px_rgba(245,158,11,0.5)] border border-white/20" data-id="element-280">
            ⭐ LA SCELTA PIÙ POPOLARE PER DOCENTI DI PRIMARIA
          </div>

          <p className="text-sm sm:text-3xl font-black text-text-main text-center mt-2 sm:mt-4 mb-3 sm:mb-10 tracking-wide" data-id="element-281">
            VALORE TOTALE DEI CONTENUTI:
          </p>

          {/* Value list */}
          <div className="space-y-2 sm:space-y-5 mb-4 sm:mb-10 text-sm sm:text-xl" data-id="element-282">
            <div className="flex justify-between text-text-main font-medium border-b border-border-light pb-1.5 sm:pb-3" data-id="element-283">
              <span data-id="element-284">Percorso Completo (6 Volumi Classe 1ª-5ª)</span>
              <span className="text-text-sec line-through ml-2 flex-shrink-0" data-id="element-285">
                € 97
              </span>
            </div>
            <div className="flex justify-between text-text-main font-medium border-b border-border-light pb-1.5 sm:pb-3" data-id="element-286">
              <span data-id="element-287">Registro Valutazione & Materiale LIM</span>
              <span className="text-text-sec line-through ml-2 flex-shrink-0" data-id="element-288">
                € 57
              </span>
            </div>
            <div className="flex justify-between text-text-main font-medium border-b border-border-light pb-1.5 sm:pb-3" data-id="element-289">
              <span data-id="element-290">Archivio Saggi, Basi e Repertorio</span>
              <span className="text-text-sec line-through ml-2 flex-shrink-0" data-id="element-291">
                € 47
              </span>
            </div>
            <div className="flex justify-between text-text-main font-medium border-b border-border-light pb-1.5 sm:pb-3" data-id="element-292">
              <span data-id="element-293">6 Bonus Esclusivi</span>
              <span className="text-text-sec line-through ml-2 flex-shrink-0" data-id="element-294">
                € 49
              </span>
            </div>

            <div className="flex justify-between text-text-main font-black pt-1 sm:pt-4 text-base sm:text-2xl" data-id="element-295">
              <span data-id="element-296">VALORE REALE:</span>
              <span className="text-badge-red line-through" data-id="element-297">€ 250</span>
            </div>
          </div>

          {/* Price reveal */}
          <div className="text-center mb-3 sm:mb-10 bg-gradient-to-b from-primary/5 to-transparent border border-white/10 py-6 sm:py-10 rounded-lg sm:rounded-2xl relative overflow-hidden" data-id="element-298">
            <div className="absolute top-0 left-0 w-full h-0.5 sm:h-1 bg-gradient-to-r from-transparent via-primary to-transparent" data-id="element-299"></div>

            {/* Original price + discount badge */}
            <div className="flex items-center justify-center gap-2 sm:gap-3 mb-2 sm:mb-4" data-id="element-300">
              <span className="text-text-sec line-through text-base sm:text-2xl font-medium" data-id="element-301">
                € 250,00
              </span>
              <span className="bg-cta-green/20 text-cta-green font-black text-[10px] sm:text-sm px-2 py-0.5 sm:px-3 sm:py-1 rounded-full" data-id="element-302">
                92% OFF
              </span>
            </div>

            {/* Big price */}
            <div className="font-black sm:text-8xl tracking-tighter transition-all text-[#FFFFFF] text-[56px]" data-id="element-303">
              € 19
            </div>

            <div className="text-text-sec text-xs sm:text-base font-medium mt-2 sm:mt-3 flex items-center justify-center gap-2" data-id="element-304">
              <span data-id="element-305">💳 Pagamento unico</span>
              <span data-id="element-306">•</span>
              <span data-id="element-307">⚡ Accesso immediato</span>
            </div>
          </div>

          {/* CTA Button */}
          <a href={CHECKOUT_URL} onClick={firePixel} className="btn-primary-pulse block w-full text-center bg-cta-green text-white font-black text-[17px] sm:text-2xl py-3.5 sm:py-6 rounded-xl sm:rounded-2xl hover:bg-cta-green-hover transition-colors shadow-[0_0_50px_rgba(22,199,132,0.6)] border border-white/20 mb-6 pt-[25px] pb-[25px]" data-id="element-308">
            <span className="hidden sm:inline" data-id="element-309">
              🚀 SÌ! VOGLIO IL KIT COMPLETO — € 19
            </span>
            <span className="sm:hidden text-[18px]" data-id="element-310">
              🚀 VOGLIO IL KIT — € 19
            </span>
          </a>

          <p className="text-center text-text-sec text-[10px] sm:text-sm font-medium mb-2 sm:mb-8 flex items-center justify-center gap-1.5 sm:gap-3 flex-wrap" data-id="element-311">
            <span data-id="element-312">⚡ Accesso Immediato</span>
            <span data-id="element-313">•</span>
            <span data-id="element-314">💳 Un solo Pagamento</span>
            <span data-id="element-315">•</span>
            <span data-id="element-316">🛡️ Garanzia 7 Giorni</span>
          </p>
        </div>
      </div>
    </section>;
}